import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { hideDialog } from "../../Actions/DialogActions";
import Button from "../../Common/Button";
import Input from "../../Common/Input/Input";

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
    client?: string;
    name?: string;
    redirectUri?: string;
    embedded?: string;
    onSubmit: (name: string, redirectUri: string, clientId: string, embedded: string) => void;
}

type State = {
    name: string;
    redirectUri: string;
    error: string;
    embedded: string;
};

export class ApplicationCreate extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            name       : props.name || "",
            redirectUri: props.redirectUri || "",
            embedded   : props.embedded || "",
            error      : "",
        };
    }

    public onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const name = e.currentTarget.name;
        const value = e.currentTarget.value;

        this.setState(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    public onCancel = (): void => {
        this.props.dispatch(hideDialog());
    };

    public onConfirm = (): void => {
        if(!this.state.name) {
            this.setState({
                error: "Invalid Name",
            });

            return;
        }

        if(!this.state.redirectUri) {
            this.setState({
                error: "Invalid Redirect URI",
            });

            return;
        }

        this.props.dispatch(hideDialog());

        this.props.onSubmit(this.state.name, this.state.redirectUri, this.props.client || "", this.state.embedded);
    };

    public render(): React.ReactNode {
        return (
            <React.Fragment>
                <Input
                    icon="tag"
                    label="Name"
                    type="text"
                    name="name"
                    value={this.state.name}
                    onChange={this.onChange}
                />
                <Input
                    icon="link"
                    label="Redirect URI"
                    type="text"
                    name="redirectUri"
                    value={this.state.redirectUri}
                    onChange={this.onChange}
                />
                {typeof this.props.embedded !== "undefined" && (
                    <Input
                        icon="anchor"
                        label="Embedded API URI"
                        type="text"
                        name="embedded"
                        value={this.state.embedded}
                        onChange={this.onChange}
                    />
                )}
                <div className="dialog-buttons">
                    <Button
                        type="button"
                        classes={[ "secondary" ]}
                        onClick={this.onCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        classes={[ "primary" ]}
                        onClick={this.onConfirm}
                    >
                        Confirm
                    </Button>
                </div>
            </React.Fragment>
        );
    }
}

export default connector(ApplicationCreate);
